// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__m0hic","label":"Checkbox_label__2mNHE"};